import { splitByTerm, type SearchTerm } from "./searchMatch";

interface SearchHighlightProps {
  text: string;
  term?: SearchTerm;
}

/** Texto com o termo da busca marcado, como o Ctrl+F do navegador. */
export function SearchHighlight({ text, term = "" }: SearchHighlightProps) {
  return (
    <>
      {splitByTerm(text, term).map((part, index) =>
        part.matched ? (
          <mark key={index} className="rounded-sm bg-amber-200/70 font-medium text-foreground">
            {part.text}
          </mark>
        ) : (
          <span key={index}>{part.text}</span>
        ),
      )}
    </>
  );
}
